"use client";

import { cn } from "@/lib/utils";
import * as React from "react";

function StepNumberWrap({
  className,
  ...props
}: Readonly<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn(
        "flex h-[39px] w-[39px] items-center justify-center rounded-full border border-black text-center",
        className,
      )}
      {...props}
    />
  );
}

export { StepNumberWrap };
